// extracted by mini-css-extract-plugin
module.exports = {"monogramBlock":"styles_monogramBlock__1M8jh","divider":"styles_divider__3YSTR","editMode":"styles_editMode__qAHAS"};